<template>
    <div class="view-bar">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "ViewBar",
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";
    .view-bar {
        background-color: var(--card-background-color);
        width: 100%;
        height: 100%;
        overflow-y: auto;
        box-shadow: 2px 0px 2px rgba(0,0,0,0.5);

        &::-webkit-scrollbar {
            width: 7px;
            height: 13px;
        }

    }


    .view-bar>* {
        width: 100%;
    }

    .view-bar>h1 {
        margin: 0;
        padding: 5px 10px 5px 10px;
        background-color: rgba(255,255,255,0.06);
        user-select: none;
    }
</style>